<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { useDropdownContext } from './provider.js';

const props = defineProps({
  label: { type: String, default: '' },
  icon: { type: [String, Object, Function], default: '' },
  iconClass: { type: String, default: 'size-4 text-n-slate-11' },
  labelClass: { type: String, default: '' },
  link: { type: [String, Object], default: '' },
  nativeLink: { type: Boolean, default: false },
  click: { type: Function, default: null },
  preserveOpen: { type: Boolean, default: false },
});

defineOptions({
  inheritAttrs: false,
});

const { closeMenu } = useDropdownContext();

const componentIs = computed(() => {
  if (props.link) {
    if (props.nativeLink && typeof props.link === 'string') {
      return 'a';
    }

    return 'router-link';
  }
  if (props.click) return 'button';

  return 'div';
});

const triggerClick = () => {
  if (props.click) {
    props.click();
  }
  if (!props.preserveOpen) {
    requestAnimationFrame(() => {
      closeMenu();
    });
  }
};
</script>

<template>
  <li class="n-dropdown-item">
    <component
      :is="componentIs"
      v-bind="$attrs"
      class="flex text-left rtl:text-right items-center py-1.5 px-2 reset-base text-sm text-n-slate-12 w-full border-0"
      :class="{
        'hover:bg-n-alpha-2 rounded-lg w-full': props.click || props.link,
        'gap-3': !$slots.default,
        'cursor-pointer': props.click || props.link,
      }"
      :href="componentIs === 'a' ? props.link : null"
      :to="componentIs === 'router-link' ? props.link : null"
      @click="triggerClick"
    >
      <slot>
        <slot name="icon">
          <Icon v-if="icon" :class="iconClass" :icon="icon" />
        </slot>
        <slot name="label">
          <span :class="labelClass">{{ label }}</span>
        </slot>
      </slot>
    </component>
  </li>
</template>
